import { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
  preview?: ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-black flex flex-col  p-4 md:p-6 lg:p-8">
      {/* Logo */}
      <div className="w-11/12 flex justify-start">
        <img src="/black_logo.svg" alt="Helpdesk 411" className="h-10 md:h-12 w-auto" />
      </div>
      <div className="flex-1 flex flex-col items-center justify-center py-8 lg:py-0">
       <div className="w-full max-w-md flex flex-col justify-center gap-8 md:gap-12">
        <div>
          {children}
        </div>
       </div>
      </div>
    </div>
  )
}
